module.exports = __webpack_public_path__ + "static/media/profile-2.bad6cb3c.jpg";